var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed, observable, reaction } from "mobx";
import { NOT_LOADED } from "../Infra/RemoteData";
import { NamedRoutes } from "./NamedRoutes";
import { NavigationHelper } from "./NavigationHelper";
import { UserType } from "healthex-common/user.dtos";
const _orgUserFirstTimeRoutes = [
    NamedRoutes.WELCOME_ORG_USER_DETAILS,
    NamedRoutes.WELCOME_BASIC_ORG_DETAILS,
    NamedRoutes.WELCOME_CUSTOMIZE_ORG_DETAILS,
    NamedRoutes.WELCOME_ORG_USER_INVITE,
];
const _researcherUserFirstTimeRoutes = [
    NamedRoutes.WELCOME_ORG_USER_DETAILS,
    NamedRoutes.WELCOME_BASIC_ORG_DETAILS,
    NamedRoutes.WELCOME_ORG_USER_INVITE,
];
export const orgUserFirstTimeRouteValues = _orgUserFirstTimeRoutes;
export const researcherUserFirstTimeRouteValues = _researcherUserFirstTimeRoutes;
const _pageToRoutes = {
    HEALTH_SYSTEM_HOME: NamedRoutes.HEALTHCARE_ORG_ANALYTICS,
    RESEARCHER_HOME: NamedRoutes.PROJECTS,
};
const pageToRoutes = _pageToRoutes;
export class WelcomeUserUIManager {
    constructor(routingUIManager, authManager, provisioningService) {
        this.routingUIManager = routingUIManager;
        this.authManager = authManager;
        this.provisioningService = provisioningService;
        this.navigationHelper = new NavigationHelper(this.routingUIManager, pageToRoutes);
        this.welcomeToken = null;
        this.authenticatedUser = NOT_LOADED;
        this.organization = NOT_LOADED;
        this.authTypeResponse = NOT_LOADED;
        reaction(() => routingUIManager.currentRoute, async () => {
            var _a, _b, _c;
            if (((_a = this.routingUIManager.currentRoute) === null || _a === void 0 ? void 0 : _a.routeName) === NamedRoutes.WELCOME.routeName && this.authManager.isLoggedIn) {
                if (this.authManager.userType === UserType.HEALTHCARE_ORGANIZATION) {
                    this.navigationHelper.redirectTo("HEALTH_SYSTEM_HOME");
                }
                else {
                    this.navigationHelper.redirectTo("RESEARCHER_HOME");
                }
            }
            if (((_b = this.routingUIManager.currentRoute) === null || _b === void 0 ? void 0 : _b.routeName) === NamedRoutes.WELCOME.routeName && !this.authManager.isLoggedIn) {
                await this.authenticateUser();
                await this.getOrganization();
                await this.fetchAuthType();
            }
            else if (((_c = this.routingUIManager.currentRoute) === null || _c === void 0 ? void 0 : _c.routeName) === NamedRoutes.WELCOME_ORG.routeName &&
                !this.authManager.isLoggedIn) {
                this.authenticatedUser = null;
                await this.getOrganization();
                await this.fetchAuthType();
            }
        });
    }
    get progressBarPercentage() {
        var _a;
        const isHealthcareOrg = this.authManager.userType === UserType.HEALTHCARE_ORGANIZATION;
        const numberOfPages = isHealthcareOrg ? orgUserFirstTimeRouteValues.length : researcherUserFirstTimeRouteValues.length;
        const onePagePercentage = 100 / numberOfPages;
        switch ((_a = this.routingUIManager.currentRoute) === null || _a === void 0 ? void 0 : _a.routeName) {
            case NamedRoutes.WELCOME_ORG_USER_DETAILS.routeName:
                return onePagePercentage;
            case NamedRoutes.WELCOME_BASIC_ORG_DETAILS.routeName:
                return onePagePercentage * 2;
            case NamedRoutes.WELCOME_CUSTOMIZE_ORG_DETAILS.routeName:
                return onePagePercentage * 3;
            case NamedRoutes.WELCOME_ORG_USER_INVITE.routeName:
                return isHealthcareOrg ? onePagePercentage * 4 : onePagePercentage * 3;
            default:
                return 0;
        }
        return 0;
    }
    async authenticateUser() {
        var _a, _b;
        this.welcomeToken = (_b = (_a = this.routingUIManager.currentRouteParams) === null || _a === void 0 ? void 0 : _a.welcomeToken) !== null && _b !== void 0 ? _b : null;
        if (!this.welcomeToken) {
            this.authenticatedUser = null;
            return;
        }
        try {
            this.authenticatedUser = await this.authManager.authenticateByToken(this.welcomeToken);
        }
        catch {
            this.authenticatedUser = null;
        }
    }
    async getOrganization() {
        var _a, _b;
        let organizationId;
        if ((_a = this.routingUIManager.currentRouteParams) === null || _a === void 0 ? void 0 : _a.welcomeOrgId) {
            organizationId = (_b = this.routingUIManager.currentRouteParams) === null || _b === void 0 ? void 0 : _b.welcomeOrgId;
        }
        else {
            if (this.authenticatedUser === NOT_LOADED || this.authenticatedUser === null)
                return;
            if (this.authenticatedUser.type === UserType.PATIENT || this.authenticatedUser.type === UserType.PATIENT_READ_ONLY)
                return;
            organizationId = this.authenticatedUser.organizationId;
        }
        try {
            this.organization = await this.provisioningService.getOrganizationPublicProfileById(organizationId);
        }
        catch {
            this.organization = null;
        }
    }
    async fetchAuthType() {
        if (this.organization === NOT_LOADED || this.organization === null)
            return;
        try {
            this.authTypeResponse = await this.authManager.getAuthTypeByOrgId(this.organization.id, `${window.location.origin}/#/user-details`);
        }
        catch {
            this.authTypeResponse = null;
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], WelcomeUserUIManager.prototype, "welcomeToken", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WelcomeUserUIManager.prototype, "authenticatedUser", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WelcomeUserUIManager.prototype, "organization", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WelcomeUserUIManager.prototype, "authTypeResponse", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], WelcomeUserUIManager.prototype, "progressBarPercentage", null);
